/* assets/frenly-hero-media-warm.js
   VF46/VF47 (2026-09-12), split out of assets/frenly-hero.js to keep that
   file under the ~40,000 char guideline (RULES.md item 7). Must load
   BEFORE frenly-hero.js (see snippets/frenly-hero-assets.liquid), which
   calls window.FrenlyHeroMediaWarm.warmPosters() at carousel init and
   .slideReadyPromise() from inside its own slide-switch tween.

   Every poster this hero could ever show, warmed with a background
   Image() fetch plus a real decode() before a pip switch ever needs it.
   The first three slides' own posters also get a <link rel=preload>
   straight from the Liquid markup (higher priority, before this script
   even runs); this covers every remaining slide plus the eBay
   auction-pool rotation posters, which only exist as JSON until
   assets/frenly-hero.js's rotateAuctionPair() picks one to actually load. */
(function () {
  "use strict";
  function collectPosterUrls(root) {
    var urls = [], seen = Object.create(null);
    function add(url) {
      if (!url || seen[url]) return;
      seen[url] = !0;
      urls.push(url);
    }
    Array.prototype.forEach.call(root.querySelectorAll("[data-fb-lazy-video]"), function (video) {
      add(video.getAttribute("data-poster") || video.getAttribute("poster"));
    });
    Array.prototype.forEach.call(root.querySelectorAll("[data-fb-auction-video-pool]"), function (poolEl) {
      try {
        var pool = JSON.parse(poolEl.textContent);
        pool.forEach(function (item) { item && add(item.poster); });
      } catch (error) { /* malformed pool JSON just skips warming, no fatal error */ }
    });
    return urls;
  }
  var posterDecodeCache = Object.create(null);
  function posterDecodePromise(url) {
    /* Resolves once the browser has actually decoded the image (or given
       up on it), never rejects, so a broken/slow poster can never hang a
       caller waiting on this. Cached so the same URL is only decoded once
       even if several slides/pool entries share it. */
    if (!url) return Promise.resolve();
    if (posterDecodeCache[url]) return posterDecodeCache[url];
    var promise = new Promise(function (resolve) {
      var img = new Image();
      img.decoding = "async";
      img.onload = function () {
        img.decode ? img.decode().then(resolve, resolve) : resolve();
      };
      img.onerror = function () { resolve(); };
      img.src = url;
    });
    posterDecodeCache[url] = promise;
    return promise;
  }
  function warmPosters(root) {
    collectPosterUrls(root).forEach(posterDecodePromise);
  }
  function slideReadyPromise(slide) {
    /* The promise a transition waits on before it reveals the incoming
       slide, so the previous slide stays the only thing painted until the
       new one's poster(s) are actually decode-ready (never an empty/black
       frame as the "settled" state of a switch). */
    if (!slide) return Promise.resolve();
    var posters = [];
    Array.prototype.forEach.call(slide.querySelectorAll("[data-fb-lazy-video]"), function (video) {
      var poster = video.getAttribute("poster");
      poster && posters.push(poster);
    });
    if (!posters.length) return Promise.resolve();
    return Promise.all(posters.map(posterDecodePromise));
  }
  window.FrenlyHeroMediaWarm = { warmPosters: warmPosters, slideReadyPromise: slideReadyPromise };
})();
